<template>
    <div>
        <!--车辆轨迹  --> 
        <el-dialog title="轨迹查看" :visible.sync="dialogVisibleDialog" width="80%"  id="loadingMap" :before-close="handleClose">
            <div class="main" >
                <div class="title_map display_flex show_text">
                     <p>经度: <span>{{showData.longitude}}</span></p>
                     <p>纬度: <span>{{showData.latitude}}</span></p>
                     <p>车辆当前时间: <span style=" width: 190px;">{{showData.time}}</span></p>
                </div>
                <!-- //容器的宽高不能少 -->
                <section class="section">
                <!-- //这里地图,style="width:100%;height:100%"这个不能少 -->
                    <div  id="container" style="width:100%;height:60vh;" />
            <!-- //这里是控制轨迹的按钮组 -->
                    <div style=" margin-top: 10px;justify-content: space-between;" class="display_flex">
                        <el-button-group>
                            <!-- <el-button type="primary" style=" margin-right: 10px;"  size="mini" @click="startAnimation()">轨迹回放</el-button> -->
                            <el-button type="primary" style=" margin-right: 10px;"   size="mini" @click="startAnimation()">开始动画</el-button>
                            <el-button type="info"  style=" margin-right: 10px;"  size="mini" @click="pauseAnimation()">暂停动画</el-button>
                            <el-button type="success" style=" margin-right: 10px;"   size="mini" @click="resumeAnimation()">继续动画</el-button>
                            <!-- <el-button type="primary" style=" margin-right: 10px;"  size="mini" @click="carFastMove()">加速</el-button>
                            <el-button type="primary"  size="mini" @click="carFastMove1()">减速</el-button> -->
                            <!-- <el-button type="primary"  size="mini" @click="stopAnimation()">停止动画</el-button> -->
                            <!-- <el-button type="danger" icon="el-icon-delete" @click='clearVehicleTrajectory'>轨迹清除</el-button> -->
                        </el-button-group>
                        <div class="title_map display_flex">
                            <p>是否为会员: <span>{{queryNums.member=='1'?'是':'否'}}</span></p>
                            <p v-if="queryNums.member=='1'">套餐剩余查询次数: <span>{{queryNums.times||'--'}}</span></p>
                            <p v-if="queryNums.member=='1'">会员到期时间: <span>{{queryNums.times||'--'}}</span></p>
                            <p v-if="queryNums.member!='1'">本月免费次数/已使用: <span>30/{{queryNums.freeMonth||'--'}}</span></p>
                            <p v-if="queryNums.member!='1'">当日免费次数/已使用: <span>10/{{queryNums.freeToday||'--'}}</span></p>
                        </div>
                    </div>
                </section>
                <!-- <div class="recharge"><span @click="$router.push('/purchaseOne')">会员充值</span></div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisibleDialog = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="dialogVisibleDialog = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:{
        // 弹框是否打开
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        mapParams:{
            type: Object,
        }
    },
    data() {
        return {
            dialogVisibleDialog:false,
            firstArr: [121.46472 , 31.41002], //中心点/初始坐标=>联调时，用后台数据将此数据覆盖
            //绘制线路需要的坐标=>联调时，用后台数据将此数据覆盖(经纬度不要写反了,反了是出不来的)
            lineArr: [
                // [116.478935, 39.997761],
            ],
            map: null,
            marker: null,
            moveSpeed:100,//需求要求改变速度的可保留
            queryNums:{
                // member:'' ,//  是否为会员，1是   2否  需要判断是否存在这个字段
                // isUnlimited:'',//   是否无限次数
                // times :'',//会员套餐剩余查询次数
                // freeMonth:'',   //本月已使用免费次数
                // freeToday:'',  // 当日已进行免费查询次数
            },
            arrLine:[],//数据请求数据
            showData:{
                longitude:'--',//经度
                latitude:'--',//纬度
                time:'--',//当前时间
            },

        }
    },
    watch: {
        dialogVisible:{ 
            handler(newV, oldV) {
                this.getTrajectory(this.mapParams)
            },
        },

    },
    methods:{
        async getTrajectory(e){
            // this.$router.push('/purchaseOne')
            // return
            console.log(e);
            //数据加载时整个页面显示loading
            const loading = this.$loading({
                //lock的修改符--默认是false
                lock: true,
                //显示在加载图标下方的加载文案
                text: "初始化地图中",
                //自定义加载图标类名(在elementUI 文档查找)
                spinner: "el-icon-loading",
                //(可以自己定义)遮罩层颜色
                background: "rgba(255, 255, 255, .7)",
                //loadin覆盖的dom元素节点(整个页面的话'#body' 表格的话'#table'等等 )
                target: document.querySelector("#loadingBox"),
            });
            let queryNum = await this.$api.twice.getQueryTimes()
            if(queryNum.status=='200'){
                // console.log(queryNum);
                this.queryNums=queryNum.data
            }
            this.$api.twice.postGetToken({
                endTime:e.endTime+'235959',
                licensePlate: e.licensePlateNum,
                // licensePlate:'沪EH6610',//车牌号
                startTime:e.billLadingDate+'000000'
            }).then(res=>{
                // console.log(res);
                if(res.status=='200'){
                // postToCarTrack
                // postVehicleTrack
                this.$api.twice.postToCarTrack({
                    accessKeyID: res.data.accessKeyID,//调用客户端 
                    authToken: "",//授权令牌
                    billLadingNum: e.billLadingNum,//提单号
                    digest: res.data.digest,//签名
                    endTime: e.endTime+'235959',//轨迹结束时间
                    licensePlate:e.licensePlateNum,//车牌号
                    // licensePlate:'沪EH6610',//车牌号
                    startTime: e.billLadingDate+'000000',//轨迹开始时间
                }).then(ele=>{
                    loading.close();
                    // console.log(ele);
                    if(ele.status=='200'){
                        if(ele.data.length){
                            this.dialogVisibleDialog=true
                            let arrData=[]
                            ele.data.forEach(item=>{
                                arrData.push([item.longitude,item.latitude])
                            })
                            this.lineArr=arrData
                            this.arrLine= ele.data
                             this.showData={
                                longitude:ele.data[0].longitude,//经度
                                latitude:ele.data[0].latitude,//纬度
                                time:this.formatMsToDate(ele.data[0].gpsTime||'')||'--' ,//当前时间
                            },
                            this.firstArr=arrData[arrData.length-1]?arrData[arrData.length-1]:[]
                            let that=this
                            this.$nextTick(()=>{
                            that.initMap() // 初始化地图
                            that.initroad()// 初始化轨迹
                            })
                        }else{
                            this.$message.warning('暂无轨迹信息')
                        }
                        
                    }else{
                        this.$message.error(ele.msg)
                    }
                    
                })
                }
            })
        },
        handleClose(){
            this.dialogVisibleDialog = false
        },
        // 初始化地图
        initMap() {
            this.map = new AMap.Map('container', {
                resizeEnable: true, // 窗口大小调整
                center: this.firstArr, // 中心 firstArr: [116.478935, 39.997761],
                zoom: 15
            })

            // 添加工具栏
            this.map.plugin(['AMap.ToolBar', 'AMap.Scale','AMap.Geolocation'], () => {
                const toolbar = new AMap.ToolBar()// 工具条
                const scale = new AMap.Scale() // 比例尺
                this.map.addControl(toolbar)
                this.map.addControl(scale)
            })
            // 添加maker
            this.marker = new AMap.Marker({
                map: this.map,
                position: this.firstArr,
                icon: 'https://webapi.amap.com/images/car.png',
                offset: new AMap.Pixel(-26, -13), // 调整图片偏移
                autoRotation: true, // 自动旋转
                angle: -90, // 图片旋转角度

            })
        },
        // 初始化轨迹
        initroad() {
            let that =this;
            // 创建一个 icon
            var startIcon = new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                imageSize: new AMap.Size(135, 40),
                imageOffset: new AMap.Pixel(-9, -3)
            });
            // 创建一个 icon
            var endIcon = new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                imageSize: new AMap.Size(135, 40),
                imageOffset: new AMap.Pixel(-95, -3)
            });
            // 将 icon 传入 marker(起始标记)
            var startMarker = new AMap.Marker({
                // position: new AMap.LngLat(116.35, 39.89),
                position: this.lineArr[0],
                icon: startIcon,
                offset: new AMap.Pixel(-13, -30)
            });
            // 将 icon 传入 marker
            var endMarker = new AMap.Marker({
                // position: new AMap.LngLat(116.45, 39.93),
                position: this.lineArr[this.lineArr.length - 1],
                icon: endIcon,
                offset: new AMap.Pixel(-13, -30)
            });
            // 将 markers 添加到地图
            this.map.add([startMarker, endMarker]);

           // 将 icon 传入 marker
            // 绘制还未经过的路线
            this.polyline = new AMap.Polyline({
                map: this.map,
                path: this.lineArr,
                showDir: true,
                strokeColor: '#28F', // 线颜色--蓝色
                // strokeOpacity: 1,     //线透明度
                strokeWeight: 10, // 线宽
                // strokeStyle: "solid"  //线样式
                lineJoin: 'round' // 折线拐点的绘制样式
            })
            // 绘制路过了的轨迹
            var passedPolyline = new AMap.Polyline({
                map: this.map,
                strokeColor: '#AF5', // 线颜色-绿色
                // path: lineArr.reverse(),
                // strokeOpacity: 1,     //线透明度
                strokeWeight: 6 // 线宽
                // strokeStyle: "solid"  //线样式
            })
            let _this=this
            this.marker.on('moving', e => {
                passedPolyline.setPath(e.passedPath)
                // console.log(e.passedPath);
                // 数据展示
                _this.showData={
                    longitude:e.passedPath[e.passedPath.length-1].lng,//经度
                    latitude:e.passedPath[e.passedPath.length-1].lat,//纬度
                    time:_this.formatMsToDate(_this.arrLine[e.passedPath.length-1].gpsTime),//当前时间
                },
                that.map.setCenter(e.target.getPosition(),true)//设置后地图跟随小车移动
            })
            this.map.setFitView() // 合适的视口
            // var infoWindow = new AMap.InfoWindow({
            //     content:"aaa"//信息窗体的内容
            // });
            // infoWindow.open(this.map,this.marker.getPosition()); //信息窗体打开
        },
        startAnimation() {//车辆轨迹回放开始
            this.marker.moveAlong(this.lineArr, 100000); //这里的1000000为速度，可根据绘制线路需要的坐标来调整
            //（调试时不要设置太小了，不然看不出来）
            // this.marker.moveAlong(this.lineArr, this.moveSpeed); 
        },
        pauseAnimation() {//车辆轨迹回放暂停
            this.marker.pauseMove();
        },
        resumeAnimation() {//车辆轨迹回放继续
            this.marker.resumeMove();
        },
        stopAnimation() {//车辆轨迹回放停止
            this.marker.stopMove();
        },
        carFastMove() {//车辆轨迹回放改变速度 加速
            this.moveSpeed = this.moveSpeed * 2;
        },
        carFastMove1(){ //减速
            this.moveSpeed = this.moveSpeed / 2;
        },
    // 表格选中单行
        handleTableRow(row, event, column) {
            const This = this
            This.firstArr = []
            This.firstArr.push(row.longitude)
            This.firstArr.push(row.latitude)
            This.initMap()//初始化地图

    //获取后台路线数据
            //This.formData.deviceNumber = row.deviceNumber
            //This.getVehicleCarGpsData()//渲染轨迹
        },
        // 轨迹清除
        clearVehicleTrajectory() {
            const This = this
            This.initMap()//初始化地图
            //This.getVehicleCarGpsData()//后台数据渲染轨迹
        },
        //该方法用于给日期、时间补零
        addZero(num) {
            if (parseInt(num) < 10) {
                num = "0" + num
            }
            return num
        },
        //把毫秒数转化成具体日期   2021-06-04 00:00:00
        //参数 毫秒数  
        formatMsToDate(ms) {
            if (ms) {
                var oDate = new Date(ms),
                    oYear = oDate.getFullYear(),
                    oMonth = oDate.getMonth() + 1,
                    oDay = oDate.getDate(),
                    oHour = oDate.getHours(),
                    oMin = oDate.getMinutes(),
                    oSen = oDate.getSeconds(),
                    oTime = oYear +'.'+ this.addZero(oMonth)  +'.'+ this.addZero(oDay)+' '+ this.addZero(oHour) + ':' + this.addZero(oMin) + ':' + this.addZero(oSen);
                return oTime;
            } else {
                return ""
            }
        },
    },
    beforeDestroy() {//离开页面，销毁掉
        this.map && this.map.destroy();
    },
    
}
</script>

<style scoped>
::v-deep .el-dialog__body{
  padding-top: 0;
  padding-bottom: 0;
}
.title_map p{
    margin-right: 40px;
    display: flex;
    align-items: center;
    flex-direction: row;
}
.title_map p span{
    color: #004593;
    font-size: 18px;
    font-weight: bold;
    margin-left: 6px;
}

.show_text  p span{
    width: 120px;
    display: block;
}
.recharge{
    text-align: center;
    color: red;
}
.recharge span{
    cursor: pointer;
}

.display_flex{
    display: flex;
    align-items: center;
    flex-direction: row;
}

</style>